import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { FiLock } from 'react-icons/fi'

const Wrapper = styled.div`
  padding-top: 2rem;
  text-align: center;
`

const LogoWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  line-height: 1;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  color: #41a6dc;
`

const InfoText = styled.div`
  font-size: 0.875rem;
`

export const SecurePaymentLogo: React.VFC = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <LogoWrapper>
        <FiLock />
        <InfoText>{t('billing.payment.securePaymentTitle')}</InfoText>
      </LogoWrapper>
      <InfoText>{t('billing.payment.securePaymentSubtitle')}</InfoText>
    </Wrapper>
  )
}
